import { cn } from '@/lib/utils';

type GridLoadingProps = {
  label?: string;
  className?: string;
};

export const GridLoading = ({
  label = 'Loading…',
  className,
}: GridLoadingProps) => (
  <div
    className={cn(
      'flex h-full animate-pulse items-center justify-center rounded bg-gray-100',
      className,
    )}
    aria-busy="true"
  >
    <div className="flex flex-col items-center gap-2">
      <span className="inline-block h-8 w-8 animate-spin rounded-full border-3 border-gray-400 border-t-transparent" />
      <span className="leading-none text-gray-500">{label}</span>
    </div>
  </div>
);
